// extracted by mini-css-extract-plugin
export default {"buttonContainer":"buttonContainer--O8JXv","disableBackground":"disableBackground--mLGSw","borderForMinus":"borderForMinus--xXRec"};